import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, Breakpoint, Button, ButtonType } from 'app/component-library-wave';

import { setCurrentStep, setToAddress } from 'app/store/actions/relocation-actions';
import { LocationSearch } from 'app/components/location-search/location-search';
import { RelocationStepId } from 'app/store/slices/relocations-slice';
import { RelocationAddress } from 'app/pages/relocation/components/relocation-address/relocation-address';
import { useAppSelector } from 'app/hooks/redux-thunk';
import { getDataLayers } from 'app/utils/trackingService';
import {
  getAnonymizedCurrentPageUrl,
  GtmElementCategory,
  GtmElementCta,
  GtmFunnelStepName,
} from 'app/utils/gtm-tracking-utils';

import styles from './relocation-step-address.module.scss';

export const RelocationStepAddress = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fromAddress = useAppSelector((state) => state.userContext.selectedCustomerLocation);
  const toAddress = useAppSelector((state) => state.relocation.toAddress);

  const handleNextClick = () => {
    getDataLayers().customEvents.pushButtonClickEvent({
      element_category: GtmElementCategory.RELOCATION,
      element_cta: GtmElementCta.RELOCATION_NEXT_STEP,
      page_url: getAnonymizedCurrentPageUrl(),
      element_description: GtmFunnelStepName.RELOCATION_LOCATION,
    });

    dispatch(setCurrentStep(RelocationStepId.DATES));
  };

  return (
    <div className={styles.locationSelectorContainer}>
      {fromAddress && (
        <Typography
          id="locationListHeader"
          className={styles.title}
          variant="headline5"
          component="h2"
          maxBreakpoint={Breakpoint.TABLET}
        >
          {t('pages.relocationForm.addressStep.fromSelectedHeader')}
        </Typography>
      )}

      {fromAddress ? (
        <RelocationAddress address={fromAddress} isDestination={false} customerType={fromAddress.customerType} />
      ) : (
        <Typography component="p" variant="paragraph1">
          {t('pages.relocationForm.addressStep.fromAddressUnselected')}
        </Typography>
      )}

      <div className={styles.toAddressContainer}>
        <Typography className={styles.title} variant="headline5" component="h2" maxBreakpoint={Breakpoint.TABLET}>
          {t('pages.relocationForm.addressStep.toUnselectedHeader')}
        </Typography>
        {toAddress ? (
          <RelocationAddress address={toAddress} isDestination={true} />
        ) : (
          <LocationSearch onSelectLocation={(address) => dispatch(setToAddress(address))} />
        )}
      </div>

      <div className={styles.nextStepContainer}>
        <Button onClick={handleNextClick} buttonType={ButtonType.PRIMARY_B} disabled={!(fromAddress && toAddress)}>
          {t('pages.relocationForm.stepsNavigation.next')}
        </Button>
      </div>
    </div>
  );
};
